type ValuesOf<T> = T[keyof T]

const roles = {
  OWNER: "owner",
  ADMIN: "admin",
  MEMBER: "member",
} as const
export type RoleTypes = ValuesOf<typeof roles>

export type LuzPlanFeatures = Record<
  | "addRemoveCompetitors" // the ability to add and remove competitors
  | "productResearch" // the ability to research products from competitors tracked by their plan
  | "apiTokens" // the ability to generate tokens to hit the API programatically
  | "benchmarking" // tool to benchmark competitors and products
  | "businessIntelligence" // can view My Store BI dashboards/visualizations
  | "websiteRetargeting" // can access the retargeting product
  | "demandPlanning" // access to tool for demand planning
  | "exportData" // has access on Reports tab to download csv's of a company's data
  | "internalTools" // can view internal tools tab and perform ops like actions
  | "lifetimeValue" // can view lifetime value tool
  | "marketingData" // can view all marketing data like emails and social media
  | "marketInsights" // the ability to use the market insights tool
  | "historicalData" // can view all historical data (instead of just 30 days) for companies they pay for
  | "pixelAttribution" // can view data related to the Luz pixel integration
  | "premiumOverview" // whether they get a premium view of EVERY overview page
  | "productsView" // the ability to see ALL product pages
  | "nonMerchant", // gets some special access and a different UI since they don't care about product data
  boolean
>
export type PlanFeatureTypes = keyof LuzPlanFeatures

const competitorStackFeatures = [
  "addRemoveCompetitors",
  "productResearch",
  "benchmarking",
  "marketingData",
  "marketInsights",
  "exportData",
  "historicalData",
] as const
const customerStackFeatures = [
  "pixelAttribution",
  "businessIntelligence",
  "websiteRetargeting",
  "demandPlanning",
  "lifetimeValue",
  "historicalData",
] as const
const coreStackFeatures = [...competitorStackFeatures, ...customerStackFeatures]
const nonMerchantStackFeatures = [
  "addRemoveCompetitors",
  "marketingData",
  "exportData",
  "historicalData",
  "apiTokens",
  "marketInsights",
  "premiumOverview",
  "nonMerchant",
] as const
const luzPackages = {
  customerStack: customerStackFeatures,
  competitorStack: competitorStackFeatures,
  coreStack: coreStackFeatures,
  plusStack: coreStackFeatures,
  nonMerchantStack: nonMerchantStackFeatures,
}

const luzFeatures: PlanFeatureTypes[] = [
  "addRemoveCompetitors",
  "productResearch",
  "benchmarking",
  "marketingData",
  "exportData",
  "historicalData",
  "apiTokens",
  "marketInsights",
  "businessIntelligence",
  "websiteRetargeting",
  "demandPlanning",
  "lifetimeValue",
  "pixelAttribution",
  "premiumOverview",
  "productsView",
  "nonMerchant",
]

export { roles, luzPackages, luzFeatures }
